import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter, map, switchMap, take } from 'rxjs/operators';
import { BrandingService } from '../services/branding.service';
import { PagesService } from '../services/pages.service';

@Injectable()
export class PageResolver  {
  constructor(public brandingService: BrandingService,
              private pagesService: PagesService) {}

  resolve(route: ActivatedRouteSnapshot) {
    const pageTitle = route.data['pageTitle'];
    return this.brandingService.getPageByTitle(pageTitle).pipe(
      filter(v => !!v),
      map(v => v.id),
      switchMap((id) => this.pagesService.getPage(id)),
      map((v: { content: unknown }) => v.content),
      take(1)
    );
  }
}
